import React from "react";
import { Grid, ListItem } from "@mui/material";
import { t } from "react-i18nify";
import { VSelect, VSelectURL, VMultiSelectURL } from "../../Widgets/Custom Inputs/Select";
import { HiddenField, VTextField } from "../../Widgets/Custom Inputs/CustomInputs";
import { ObjectSelector } from "./ObjectSelector";
import { querySharingTypes } from "../../../js/constants/selectOptions";
import { useState } from "react";
import { useSelector } from "react-redux";
import { fetchData } from "../../../js/utils/backend";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";

/** Step of a FormStepper: Consists of small form and an ObjectSelector to select one or several entities of interest before defining rules for them in a QueryBuilder step. */
const StepObjectSelection = ({ fieldName }) => {
    const [optionsObjects, setOptionsObjects] = useState([]);
    const { MetaCompanyManager, CompanyManager, HoldingManager, BranchManager } = useSelector(
        (state) => state.auth
    );
    const locale = useSelector(state => state.i18n.locale);
    const rightToShareToOT = MetaCompanyManager || CompanyManager || HoldingManager || BranchManager;
    const methods = useFormContext({
        mode: "onChange",
        reValidateMode: "onChange",
    });
    const { watch, unregister, setValue } = methods;
    const token = useSelector((state) => state.auth.Token);
    useEffect(() => {
        let isSubscribed = true;
        const fetching = async () => {
            const options = await fetchData("/Grid/Entities", token, "List");
            if (isSubscribed) {
                setOptionsObjects(options.data.Entities);
            }
        };
        fetching();
        return () => (isSubscribed = false);
    }, [token, locale]);
    const shareEntity = watch("Share") === "Entity";
    const shareUsers = watch("Share") === "Users";

    useEffect(() => {
        !shareEntity && unregister("OTEntityID");
        // eslint-disable-next-line
    }, [shareEntity]);

    useEffect(() => {
        !shareUsers && unregister("SharedUserIDs");
        // eslint-disable-next-line
    }, [shareUsers]);

    return (
        <>
            <Grid item xs={12}>
                <VTextField
                    label={t("field.Title")}
                    fieldName={"Value"}
                    validation={{
                        required: t("input.validation.required"),
                    }}
                />
            </Grid>
            <Grid item xs={watch("Share") === "Entity" ? 6 : 12}>
                <VSelect
                    label={t("field.Share")}
                    fieldName="Share"
                    options={
                        rightToShareToOT
                            ? querySharingTypes.map(e => ({...e, label: t(e.label)}))
                            : querySharingTypes.filter(
                                  (e) => e.value !== "OneTsigane"
                              )
                    }
                    defaultValue={null}
                    validation={{
                        required: t("input.validation.required"),
                    }}
                />
            </Grid>
            {watch("Share") === "Entity" && (
                <>
                    <HiddenField fieldName="OTEntity_select" />
                    <Grid item xs={6}>
                        <VSelectURL
                            label={t("field.Entity")}
                            URL={`OTEntity`}
                            fieldName={"OTEntityID"}
                            validation={{
                                required: t("input.validation.required"),
                            }}
                            defaultValue={watch("OTEntity_select")}
                            selectorContent={(e) =>
                                setValue("OTEntity_select", e)
                            }
                        />
                    </Grid>
                </>
            )}
            {watch("Share") === "Users" && (
                <Grid item xs={6}>
                    <VMultiSelectURL
                        label={t("common.Users")}
                        URL={`user`}
                        fieldName={"SharedUserIDs"}
                        selectRoute={"Select"}
                        defaultValue={watch("SharedUsers_select") ?? []}
                        validation={{
                            required: t("input.validation.required"),
                        }}
                        renderOption={(props, option, { selected }) => (
                            <ListItem {...props} key={option.ObjectID}>
                                {option.Name || option.Value}
                            </ListItem>
                        )}
                        disableCloseOnSelect
                    />
                </Grid>
            )}
            <Grid item xs={12}>
                <ObjectSelector
                    allOptions={optionsObjects}
                    fieldName={fieldName}
                    validation={{
                        required: t("input.validation.required"),
                    }}
                />
            </Grid>
        </>
    );
};

export default StepObjectSelection;
